// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Nqr74","content":"styles_content__p1awr","spinner":"styles_spinner__tYU1c"};